import { APP_COLOR, APP_HOVER_COLOR, BORDER_COLOR, FONT_FAMILY, TEXT_COLOR } from "../../theme";

export const styles = {
    button: {
        borderRadius: "var(--radius-md, 8px)",
        textTransform: "none",
        color: "black",
        "&:hover": {
            backgroundColor: APP_HOVER_COLOR,
        },
        backgroundColor: APP_COLOR,
        fontFamily: FONT_FAMILY,
        fontSize: 16,
        fontWeight: "bold",
    } as const,
    skipButton: {
        borderRadius: "var(--radius-md, 8px)",
        color: TEXT_COLOR,
        fontWeight: "bold",
        border: `1px solid ${BORDER_COLOR}`,
        background:
            "var(--Component-colors-Components-Buttons-Secondary-button-secondary-bg, #161B26)",
        boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
        textTransform: "none",
        fontSize: "16px",
        "&:hover": {
            boxShadow:
                "0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px rgba(158, 119, 237, 0.24)",
        },
    } as const,
    spanContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "3px",
    } as const,
}